import React from 'react'
import { CircularProgress, Grid, Typography, Divider, TextField, FormControlLabel, RadioGroup, FormControl, Radio } from '@material-ui/core'
import { Page, Header, CustomButton, SecaoGenerica } from 'components'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { cutMaxLength } from 'utils/helpers'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import useStyles from './styles'
import { usePassarCustodia } from './hooks/usePassarCustodia'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

export const PassarCustodia = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    formPassagemCustodia,
    usuarios,
    processandoUsuarios,
    processandoVestigio,
    processandoOperacao,
    isFormError,
    handleSolicitarPassagemCustodia,
    router,
    params,
  } = usePassarCustodia()

  const isLoading = processandoVestigio || processandoUsuarios

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />

      <div className={classes.results}>
        {isLoading ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          <Grid container spacing={3} style={{ marginTop: '16px' }}>



            <Grid item md={3} sm={6} xs={12}>
              <TextField
                id="lacre"
                error={formPassagemCustodia.hasError('lacre')}
                fullWidth
                helperText={formPassagemCustodia.hasError('lacre') ? formPassagemCustodia.formState.errors.lacre[0] : null}
                label="LACRE"
                name="lacre"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={formPassagemCustodia.formState.values.lacre || ''}
                required
                onChange={(e) => formPassagemCustodia.handleChangeWithModification(e, maxLength250)}
              />
              <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
                Caracteres restantes: {250 - (formPassagemCustodia.formState.values.lacre?.length || 0)}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>TIPO DA EMBALAGEM</Typography>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  aria-label="tipo-embalagem"
                  name="tipoEmbalagem"
                  value={formPassagemCustodia.formState.values.tipoEmbalagem || null}
                  onChange={formPassagemCustodia.handleChange}
                  style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}
                >
                  <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                  <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                  <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                  <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                  <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                  <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
                </RadioGroup>
              </FormControl>
            </Grid>

            {formPassagemCustodia.formState.values.tipoEmbalagem === 'OUTRO' && (
              <Grid item xs={12}>
                <TextField
                  label="OUTRO TIPO DE EMBALAGEM"
                  name="outroTipoEmbalagem"
                  variant="outlined"
                  value={formPassagemCustodia.formState.values.outroTipoEmbalagem || ''}
                  onChange={formPassagemCustodia.handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}


            {/* Seção: Dados da Passagem de Custódia */}
            <Grid item xs={12}>
              <SecaoGenerica titulo="Dados da Passagem de Custódia" spacing={3}>
                <Grid item xs={12}>
                  <AutocompleteNative
                    name="usuarioDestino"
                    noOptionsText="Sem informações"
                    options={usuarios}
                    value={formPassagemCustodia.formState.values.usuarioDestino || null}
                    onChange={(event, newValue) => {
                      formPassagemCustodia.handleChangeNewValueByNameProperty(event, newValue, 'usuarioDestino')
                    }}
                    getOptionSelected={(option, value) => option.id === value?.id}
                    getOptionLabel={(option) => `${option.nome || ''}${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
                    renderOption={(option) => `${option.nome || ''}${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="USUÁRIO DESTINO (MESMO SETOR)"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    id="observacao"
                    error={formPassagemCustodia.hasError('observacao')}
                    fullWidth
                    variant="outlined"
                    helperText={formPassagemCustodia.hasError('observacao') ? formPassagemCustodia.formState.errors.observacao[0] : null}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="observacao"
                    multiline
                    onChange={(e) => formPassagemCustodia.handleChangeWithModification(e, maxLength250)}
                    value={formPassagemCustodia.formState.values.observacao || ''}
                    minRows={5}
                    label="OBSERVAÇÃO"
                    required
                  />
                  <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
                    Caracteres restantes: {250 - (formPassagemCustodia.formState.values.observacao?.length || 0)}
                  </Typography>
                </Grid>
              </SecaoGenerica>
            </Grid>

            {/* Rodapé e Ações */}
            <Grid item xs={12}>
              <Divider />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', width: '100%', alignItems: 'center' }}>
                <CustomButton
                  colorType="primary"
                  variant="outlined"
                  onClick={() => router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)}
                  startIcon={<ArrowBackIcon />}
                >
                  Voltar
                </CustomButton>
                <CustomButton
                  colorType="primary"
                  disabled={isFormError || processandoOperacao}
                  isLoading={processandoOperacao}
                  startIcon={<CheckIcon />}
                  onClick={handleSolicitarPassagemCustodia}
                >
                  Confirmar
                </CustomButton>
              </div>
            </Grid>

          </Grid>
        )}
      </div>
    </Page>
  )
}
export default PassarCustodia
